import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import { Image, Col, Row, Button } from "react-bootstrap";
import { MdSearch } from "react-icons/md";
import editpic from "../../assets/edit.svg";
import deletepic from "../../assets/delete.svg";
import iicon from "../../assets/i-icon.svg";
import iconInfo from "../../assets/i.svg";
import messageInfo from "../../assets/temp-name.svg";
import tempSub from "../../assets/temp-sub.svg";
import Loader from "../Loader/Loader";
import { DeleteCoupons } from "./../API/Coupons/DeleteCoupons";
import { UpdateStatus } from "./../API/Coupons/UpdateStatus";
import { TableListApi } from "../API/Communications/TableList";
import { DeleteTemplateApi } from "../API/Communications/DeleteRow";
import swal from "sweetalert";
import SideBar from "../SideBar/SideBar";
import TabsSection from "../Tabs/TabsSection";
import { MdKeyboardArrowLeft } from "react-icons/md";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import emailSent from "../../assets/emailSent.svg";
import emailOpened from "../../assets/emailOpened.svg";
import TotalClick from "../../assets/totalClick.svg";
import { FaSort, FaSortUp, FaSortDown } from "react-icons/fa";
import Pagination from "../Pagination/Pagination";
import NoDataText from "../NoDataText";
import SearchBarResults from "../Search/SearchBarResults";
import BackButton from "../BackButton/BackButton";
import { FormatDateShortMonth } from "../../Utils/DateFormatter";

export const ViewTemplate = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [TableRows, setTableRows] = useState([]);
  const [globalTableRows, setglobalTableRows] = useState([]);
  const [ShowTable, setShowTable] = useState(false);
  const [tableRowLength, setTableRowLength] = useState(TableRows.length);

  // checkbox
  const [isCheckAll, setIsCheckAll] = useState(false);
  const [isCheck, setIsCheck] = useState([]);
  // AutoPublish
  const [AutoPublish, setAutoPublish] = useState([]);
  const [checkAutoPublish, setcheckAutoPublish] = useState(false);

  // templte details
  const [templateName, settemplateName] = useState("");
  const [templateSubject, settemplateSubject] = useState("");
  const [CardData, setCardData] = useState({
    sent: "",
    opened: "",
    clicks: "",
  });

  // pagination
  const [totalPageCount, setTotalPageCount] = useState(0);
  const [pageNumber, setPageNumber] = useState(0);
  const [limit, setLimit] = useState(0);

  // search
  const [searchValue, setsearchValue] = useState("");
  // sort
  const [flag, setFlag] = useState({
    mmsc_el_email_status: 0,
    user_name: 0,
    audience: 0,
    user_email: 0,
    created_at: 0
  });
  const [colValue, setColValue] = useState("created_at");
  const [sortKey, setSortKey] = useState(0);

  // pagination
  const pageChange = async (templateID) => {
    const cityId = localStorage.getItem("cityId");
    const data = {
      user_id: parseInt(cityId),
      template_id: parseInt(templateID),
      limit: 5,
      offset: pageNumber,
      sort_type: sortKey,
    };
    const coupondetailData = await TableListApi(data, () => {
      navigate("/");
    });
    if (coupondetailData.status === 429) {
      setLoading(true);
      swal({
        text: `${coupondetailData.message}`,
        icon: "error",
        buttons: "Ok",
        dangerMode: false,
      });
    } else if (coupondetailData.message == "No data found") {
      swal({
        text: `${coupondetailData.message}`,
        icon: "error",
        buttons: "Ok",
      });
      setTimeout(() => {
        navigate("/communications/manage-templates");
      }, 2000);
    } else {
      settemplateName(coupondetailData.data[0].template_name);
      settemplateSubject(coupondetailData.data[0].email_subject);
      setCardData({
        sent: coupondetailData.data[0].total_email_sent,
        opened: coupondetailData.data[0].opened_count,
        clicks: coupondetailData.data[0].total_clicks,
      });
      // table

      if (coupondetailData.data[0].email_data.length === 0) {
        setShowTable(true);
        setLoading(false);
      } else {
        setShowTable(false);
        setTableRows(coupondetailData.data[0].email_data);
        setglobalTableRows(coupondetailData.data[0].email_data);
        setTotalPageCount(coupondetailData.total_row_count);
        setLimit(5);
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    setLoading(true);
    const getTemplateName = window.location.href.split("=");
    pageChange(getTemplateName[1]);
  }, [pageNumber]);
  // checkbox - th
  const handleSelectAll = (e) => {
    setIsCheckAll(!isCheckAll);
    setIsCheck(TableRows.map((li) => li.template_id));
    if (isCheckAll) {
      setIsCheck([]);
    }
  };
  // checkbox - tr
  const handleClick = (e, key) => {
    const { checked } = e.target;
    setIsCheck([...isCheck, TableRows[key].template_id]);
    if (!checked) {
      setIsCheck(isCheck.filter((item) => item !== TableRows[key].template_id));
    }
  };

  const handleChangeDropDownTop = (e) => {
    setLoading(true);
    const cityId = localStorage.getItem("cityId");
    const data = {
      mms_city_id: parseInt(cityId),
      option: "status",
      coupon_id: isCheck,
      status_id: parseInt(e.target.value),
    };
    const coupondetailData = UpdateStatus(data, () => {
      navigate("/");
    });
    setTimeout(() => {
      window.location.reload(false);
    }, 1000);
    setLoading(false);
  };

  // Delete
  const handleDelete = () => {
    setLoading(true);
    const cityId = localStorage.getItem("cityId");
    const template_ids = isCheck.toString();
    const data = {
      user_id: parseInt(cityId),
      template_id: parseInt(template_ids),
    };
    swal({
      title: `Are you sure you want to delete selected Templates?`,
      text: "Once deleted, you will not be able to recover!",
      icon: "error",
      buttons: true,
      dangerMode: false,
    }).then((willDelete) => {
      if (willDelete) {
        DeleteTemplateApi(data, () => {
          navigate("/");
        });
        swal({
          // title: "Success!",
          title: `Selected Templates has been deleted successfully!`,
          icon: "success",
          buttons: false,
        });
        setTimeout(() => {
          window.location.reload(false);
        }, 1000);
      } else {
        swal({
          text: "Please wait...",
          icon: "error",
          buttons: "Ok",
        });

        setTimeout(() => {
          window.location.reload(false);
        }, 1000);
      }
    });
    setLoading(false);
  };

  const handleDeleteEach = (e, key) => {
    setLoading(true);
    const cityId = localStorage.getItem("cityId");
    const data = {
      user_id: parseInt(cityId),
      template_id: TableRows[key].template_id,
    };
    swal({
      title: `Are you sure you want to delete ${TableRows[key].template_name}?`,
      text: "Once deleted, you will not be able to recover!",
      icon: "error",
      buttons: true,
      dangerMode: false,
    }).then((willDelete) => {
      if (willDelete) {
        DeleteTemplateApi(data, () => {
          navigate("/");
        });
        swal({
          // title: "Success!",
          title: `${TableRows[key].template_name} has been deleted successfully!`,
          icon: "success",
          buttons: false,
        });
        setTimeout(() => {
          window.location.reload(false);
        }, 1000);
      } else {
        swal({
          text: "Please wait...",
          icon: "error",
          buttons: "Ok",
        });

        setTimeout(() => {
          window.location.reload(false);
        }, 1000);
      }
    });
    setLoading(false);
  };

  const handlecreateTemplate = () => {
    navigate("/communications/manage-templates/create-template");
  };

  // function to sort-button
  const HandleSortCol = (value) => {
    setColValue(value)
    // mmsc_el_email_status: 0,
    if (value == "user_name") {

      if (flag.user_name === 0) {

        setSortKey(1);
        setFlag((item) => {
          return { ...item, user_name: 1 };
        });
      } else if (flag.user_name === 1) {

        setSortKey(2);
        setFlag((item) => {
          return { ...item, user_name: 2 };
        });
      } else {

        setSortKey(0);
        setFlag((item) => {
          return { ...item, user_name: 0 };
        });
      }
    }

    if (value == "audience") {

      if (flag.audience === 0) {

        setSortKey(1);
        setFlag((item) => {
          return { ...item, audience: 1 };
        });
      } else if (flag.audience === 1) {

        setSortKey(2);
        setFlag((item) => {
          return { ...item, audience: 2 };
        });
      } else {

        setSortKey(0);
        setFlag((item) => {
          return { ...item, audience: 0 };
        });
      }
    }

    if (value == "user_email") {

      if (flag.user_email === 0) {

        setSortKey(1);
        setFlag((item) => {
          return { ...item, user_email: 1 };
        });
      } else if (flag.user_email === 1) {

        setSortKey(2);
        setFlag((item) => {
          return { ...item, user_email: 2 };
        });
      } else {

        setSortKey(0);
        setFlag((item) => {
          return { ...item, user_email: 0 };
        });
      }
    }

    if (value == "created_at") {

      if (flag.created_at === 0) {

        setSortKey(1);
        setFlag((item) => {
          return { ...item, created_at: 1 };
        });
      } else if (flag.created_at === 1) {

        setSortKey(2);
        setFlag((item) => {
          return { ...item, created_at: 2 };
        });
      } else {
        setSortKey(0);
        setFlag((item) => {
          return { ...item, created_at: 0 };
        });
      }
    }
    if (value == "email_status") {
      if (flag.mmsc_el_email_status === 0) {
        setSortKey(1);
        setFlag((item) => {
          return { ...item, mmsc_el_email_status: 1 };
        });
      } else if (flag.mmsc_el_email_status === 1) {

        setSortKey(2);
        setFlag((item) => {
          return { ...item, mmsc_el_email_status: 2 };
        });
      } else {

        setSortKey(0);
        setFlag((item) => {
          return { ...item, mmsc_el_email_status: 0 };
        });
      }
    }
  };

  console.log("colValue",colValue)

  const handleSort = async () => {
    try {
      const cityId = localStorage.getItem("cityId");
      const getTemplateId = window.location.href.split("=");
      const data = {
        user_id: parseInt(cityId),
        offset: pageNumber,
        search_key: searchValue,
        sort_type: sortKey,
        template_id: parseInt(getTemplateId[1]),
        limit: 5,
        column_name: colValue 

      };
      const Response = await TableListApi(data, () => {
        navigate("/");
      });
      setLoading(false);
      if (Response.data[0].email_data.length === 0) {
        setShowTable(true);
        setLoading(false);
      } else if (Response.status === 429) {
        setLoading(true);
        swal({
          text: `${Response.message}`,
          icon: "error",
          buttons: "Ok",
          dangerMode: false,
        });
      } else {
        setShowTable(false);
        setTableRows(Response.data[0].email_data);
        setLoading(false);
        setTableRowLength(Response)
      }
    } catch (err) {
      console.log("error", err)
    }

  };

  // search
  const handleSearchInput = (e) => {
    setsearchValue(e.target.value);
    if (e.target.value.length == 0) {
      setShowTable(false);
      handleSort()
    }
  };
  const handleKeypress = (e) => {
    if (e.code === "Enter") {
      handleSort();
    }
  };



  useEffect(() => {
    handleSort()
  }, [sortKey, colValue,pageNumber,searchValue])

  function capitalizeFirst(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  return (
    <>
      {loading ? <Loader /> : ""}
      <div className="gray-bg">
        <div className="navbar-section p-0">
          <SideBar />
        </div>
        <div className="main-content pt-5 pr-3 pb-4">
          <BackButton />
          <p className="page-maintitle">Communications</p>
          <div className="acc-dashboard mt-4">
            <TabsSection />

            {/* strt */}
            <div className="manage-vou-main pt-3 pb-3">
              <div className="d-flex">
                <p className="page-maintitle pt-1">Analytics Of email sent</p>
                <div>
                  {["top"].map((placement) => (
                    <OverlayTrigger
                      key={placement}
                      placement={placement}
                      overlay={
                        <Tooltip
                          id={`tooltip-${placement}`}
                          className="Tooltips"
                          style={{ opacity: "1" }}
                        >
                          This page shows the analytics report of the emails
                          sent for the selected template.
                        </Tooltip>
                      }
                    >
                      <Image
                        src={iconInfo}
                        className="pt-1"
                        width="20px"
                      ></Image>
                    </OverlayTrigger>
                  ))}
                </div>
              </div>
              <div className="manage-vou">
                <InputGroup className="search-bar">
                  <InputGroup.Text>
                    <MdSearch />
                  </InputGroup.Text>

                  <Form.Control
                    value={searchValue}
                    className="search_feild"
                    onChange={(e) => handleSearchInput(e)}
                    onKeyPress={handleKeypress}
                  />
                  <Button variant="outline-secondary" onClick={handleSort}>
                    Search
                  </Button>
                </InputGroup>
              </div>
            </div>
            <SearchBarResults SearchValue={searchValue} />

            {/*Template-info*/}
            <div style={{ padding: "20px 10px 0px" }}>
              <div className="d-flex pb-3 temp_name">
                <div className="d-flex temp_div">
                  <img src={messageInfo} />
                  <p className="template_title">Template Name</p>
                </div>

                <div className="d-flex temp_div1">
                  <p>:</p>
                  <p className="template_title_val">{templateName}</p>
                </div>
              </div>
              <div className="d-flex pb-3 temp_name">
                <div className="d-flex temp_div">
                  <img src={tempSub} className="tempSub" />
                  <p className="template_title">Template Subject</p>
                </div>

                <div className="d-flex temp_div1">
                  <p>:</p>
                  <p className="template_title_val">{templateSubject}</p>
                </div>
              </div>
            </div>

            {/*Template-card  */}
            <Row className="dashboard-card temp-dash-card mt-4 pt-2">
              <Col md="6" lg="6" className="mb-2">
                <div className="card">
                  <Image src={emailSent} className="template-images"></Image>
                  <div className="dash-content">
                    <p className="dash-text1 pt-4">Total Email sent</p>
                    <p className="dash-text2">{CardData.sent}</p>
                    <p className="text-right pb-4"></p>
                  </div>
                </div>
              </Col>
              <Col md="6" lg="6" className="mb-2">
                <div className="card">
                  <Image src={emailOpened} className="template-images"></Image>
                  <div className="dash-content">
                    <p className="dash-text1 pt-4">Total Email Opened</p>
                    <p className="dash-text2">{CardData.opened}</p>
                    <p className="text-right pb-4"></p>
                  </div>
                </div>
              </Col>

              {/* <Col md="6" lg="4" className="mb-2">
                <div className="card">
                  <Image src={TotalClick} className="template-images"></Image>
                  <div className="dash-content">
                    <p className="dash-text1 pt-4">Total Clicks</p>
                    <p className="dash-text2">{CardData.clicks}</p>
                    <p className="text-right pb-4"></p>
                  </div>
                </div>
              </Col> */}
            </Row>
            {/* table */}

            <div className="table-responsive-xl black-header">
              <table className="recentact-table mt-3 table ver-middle manage-vou-table">
                <thead>
                  <tr>
                    <th style={{ textAlign: "left" }} onClick={() => HandleSortCol("user_name")}>Business/Customer Name
                      {flag.user_name === 0 ? (
                        <FaSort></FaSort>
                      ) : flag.user_name === 1 ? (
                        <FaSortUp></FaSortUp>
                      ) : (
                        <FaSortDown></FaSortDown>
                      )}
                    </th>
                    <th style={{ textAlign: "left" }} onClick={() => HandleSortCol("audience")}>Business/Customer
                      {flag.audience === 0 ? (
                        <FaSort></FaSort>
                      ) : flag.audience === 1 ? (
                        <FaSortUp></FaSortUp>
                      ) : (
                        <FaSortDown></FaSortDown>
                      )}</th>
                    <th style={{ textAlign: "left" }} onClick={() => HandleSortCol("user_email")}>Email Address
                      {flag.user_email === 0 ? (
                        <FaSort></FaSort>
                      ) : flag.user_email === 1 ? (
                        <FaSortUp></FaSortUp>
                      ) : (
                        <FaSortDown></FaSortDown>
                      )}</th>
                    <th style={{ textAlign: "left" }} onClick={() => HandleSortCol("created_at")}>Date Sent
                      {flag.created_at === 0 ? (
                        <FaSort></FaSort>
                      ) : flag.created_at === 1 ? (
                        <FaSortUp></FaSortUp>
                      ) : (
                        <FaSortDown></FaSortDown>
                      )}
                    </th>

                    <th onClick={() => HandleSortCol("email_status")}>
                      Status
                      {flag.mmsc_el_email_status === 0 ? (
                        <FaSort></FaSort>
                      ) : flag.mmsc_el_email_status === 1 ? (
                        <FaSortUp></FaSortUp>
                      ) : (
                        <FaSortDown></FaSortDown>
                      )}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {ShowTable == false ? (
                    <>
                      {TableRows.map((item, key) => {
                        const DateValue = new Date(item.email_sent_at);
                        var hours = DateValue.getHours();
                        const minutes = DateValue.getMinutes();
                        const AmOrPm = hours >= 12 ? "PM" : "AM";
                        hours = hours % 12 || 12;
                        const finalTime = hours + ":" + minutes + " " + AmOrPm;

                        return (
                          <tr key={key}>
                            <td style={{ textAlign: "left" }}>
                              {item.business_name?.split(' ').slice(0, 10).join(' ') + (item.business_name?.split(' ').length > 10 ? '...' : '')}
                            </td>
                            <td style={{ textAlign: "left" }}>
                              {item.user_type ? capitalizeFirst(item.user_type) : "-"}
                            </td>
                            <td style={{ textAlign: "left" }}>
                              {item.business_email}
                            </td>
                            <td
                              className="date-col"
                              style={{ textAlign: "left" }}
                            >
                              {`${FormatDateShortMonth(
                                item.email_sent_at
                              )} | ${finalTime}`}
                            </td>
                            <td style={{ textAlign: "left" }}>
                              <div className={`status_bg_${item.email_status}`}>
                                {item.email_status}
                              </div>
                            </td>
                          </tr>
                        );
                      })}
                    </>
                  ) : (
                    <tr className="toggle-row">
                      <td colspan="8">
                        <p className="noData">{NoDataText.ErrText}</p>{" "}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            {tableRowLength.total_row_count > 5 ? (
              <Pagination
                totalPageCount={totalPageCount}
                setPageNumber={setPageNumber}
                limit={limit}
              />
            ) : (
              <></>
            )}

            {/* end */}
          </div>
        </div>
      </div>
    </>
  );
};
